module.exports = __webpack_public_path__ + "img/Terraform.9663484.svg";